import useGetApi from '../useGetApi';
import {
  ListQuoteSheetsResponse,
  QuoteSheetFilters,
} from './quote-sheets-types';

// Utility function to remove undefined and empty string values from filters
function cleanFilters(filters: QuoteSheetFilters): Partial<QuoteSheetFilters> {
  const cleanedFilters: Partial<QuoteSheetFilters> = {};

  Object.entries(filters).forEach(([key, value]) => {
    // Only include values that are not undefined, null, or empty strings
    if (value !== undefined && value !== null && value !== '') {
      (cleanedFilters as Record<string, unknown>)[key] = value;
    }
  });

  return cleanedFilters;
}

export function useListQuoteSheets(filters: QuoteSheetFilters) {
  return useGetApi<ListQuoteSheetsResponse>({
    endpoint: 'accounts-payable/quote-sheets',
    queryParameters: cleanFilters(filters),
  });
}
